import styled from 'styled-components';

export const StyledSelect = styled.select`
    background-color: rgba(0, 0, 0, 0);
    border: none;
    outline: none;
    color: white;
    margin-left: 0.5rem;
    text-align: right;
    font-size: 14px;

    @media (max-width: 650px) {
        font-size: 12px;
    }

    &.super {
        color: #ff0000;
    }

    &.partner {
        color: rgb(0, 255, 0);
    }
`
export const StyledOption = styled.option`
    background-color: #416043;
    border: none;
    outline: none;
    color: white;
    font-size: 14px;

    @media (max-width: 650px) {
        font-size: 12px;
    }
`